<script setup>
import {
  getApiMinimumsalaryByEditionIdStructure,
  postApiMinimumsalaryByEditionIdCriteriaByCriteriaStructureId,
  postApiMinimumsalaryByEditionIdResult
} from '@/gav-client'
import { ref } from 'vue'
import { useGAVStore, useLohndatenStore, useResultStore } from '@/stores/lohndaten'
import ProgressIndicator from './ProgressIndicator.vue'

import { gavClient as client } from '../lohnrechner'
import { useTextStore } from '@/stores/texts'
import { watch } from 'vue'
import { inject } from 'vue'
import posthog from 'posthog-js'

const openMindestlohn = ref(false)
const emit = defineEmits(['complete'])
const textStore = useTextStore()

const gavStore = useGAVStore()

const form$ = ref(null)

const store = useLohndatenStore()
const resultStore = useResultStore()

const contracts = ref([])

const total = ref(10)

const edition = ref(null)
const link = ref(null)

const structure = ref(null)
const choices = ref([])
const criteriaChoices = ref({})

const dependencies = ref({})

const buildingForm = ref(true)

const base_url = import.meta.env.VITE_API_HOST
const loading = ref(false)

async function searchContracts() {
  if (store.branche == null || store.onrp == null) {
    return
  }
  contracts.value = []
  let pk_industry = store.branche
  let pk_gemeinde = store.onrp

  let params = new URLSearchParams()
  params.append('industry', pk_industry)
  params.append('gemeinde', pk_gemeinde)
  params.append('language', textStore.language)
  loading.value = true

  let url = `${base_url}/lohnrechner/gav-search/?${params.toString()}`

  let data = await fetch(url).then((response) => response.json())

  contracts.value = data.contracts

  edition.value = null
  if (contracts.value.length > 0) {
    edition.value = contracts.value[0].editionId
    fetchStructure()
  } else {
    edition.value = null
  }
  loading.value = false
}

watch(
  () => [store.onrp, store.branche],
  () => {
    resetProgress()
    searchContracts()
  }
)

searchContracts()

function canMoveForward() {
  const currentStep = value.value
  const currentCriteria = choices.value[currentStep]
  if (!currentCriteria) return false

  return gavStore.answers[currentCriteria.id] != null
}

async function insertCriteria(criteria, parent = null) {
  if (parent) {
    dependencies.value[parent.id] = dependencies.value[parent.id] || []
    dependencies.value[parent.id].push(criteria)
  }
  choices.value.push(criteria)
  if (criteria.children) {
    criteria.children.forEach((child) => {
      insertCriteria(child, criteria)
    })
  }
}

function getRulesList() {
  return Object.keys(gavStore.answers)
    .map((item) => {
      return gavStore.answers[item]
    })
    .filter((item) => item != null)
}

async function fetchChoicesForCriteria(edition, criteria) {
  return await postApiMinimumsalaryByEditionIdCriteriaByCriteriaStructureId({
    client,
    path: {
      editionId: edition,
      criteriaStructureId: criteria.id
    },
    query: {
      language: textStore.language
    },
    body: getRulesList()
  }).then((response) => {
    if (response.error) {
      criteriaChoices.value[criteria.id] = []
      gavStore.answers[criteria.id] = {
        CriteriaStructureId: criteria.id,
        CriteriaListEntryId: null,
        Value: null
      }
      return
    }
    if (response.data.length === 1 && response.data[0].criteriaListEntryId === null) {
      criteriaChoices.value[criteria.id] = []
      gavStore.answers[criteria.id] = response.data[0]
      return
    }
    criteriaChoices.value[criteria.id] = response.data.map((item) => {
      return {
        payload: JSON.stringify({
          CriteriaStructureId: criteria.id,
          CriteriaListEntryId: item.criteriaListEntryId,
          Value: item.value
        }),
        label: item.value
      }
    })
  })
}

const gavHasNoSalary = ref(false)

async function fetchStructure() {
  return await getApiMinimumsalaryByEditionIdStructure({
    client,
    query: { language: textStore.language },
    path: { editionId: edition.value }
  }).then((response) => {
    structure.value = response.data
    response.data.forEach((element) => insertCriteria(element))
    if (choices.value.length > 0) {
      fetchChoicesForCriteria(edition.value, choices.value[0])
      total.value = choices.value.length + 1
      buildingForm.value = false
      gavHasNoSalary.value = false
    } else {
      gavHasNoSalary.value = true
    }
  })
}

function checkPrefill(el, choice) {
  if (el.value) {
    return
  }
  const options = criteriaChoices.value['' + choice.id]
  let option = null

  if (!options) {
    return
  }

  if (choice.name == 'Alter') {
    const userAge = resultStore.request.age
    option = options.find((option) => option.label == userAge)
  }
  if (choice.name == 'Kanton') {
    const userCanton = resultStore.request.plz.canton.name
    option = options.find((option) => option.label == userCanton)
  }
  if (choice.name == 'Jahr') {
    let year = new Date().getFullYear()
    option = options.find((option) => option.label == year)
    if (!option) {
      // Just use the highest year if the current year is not available
      option = options.sort((a, b) => b.label - a.label)[0]
    }
  }

  if (option) {
    el.load(option.payload)
    gavStore.answers[choice.id] = JSON.parse(option.payload)
  } else {
    if (gavStore.answers[choice.id]) {
      el.load(JSON.stringify(gavStore.answers[choice.id]))
    }
  }
}

watch(edition, () => {
  if (edition.value) {
    for (let contract of contracts.value) {
      if (contract.editionId == edition.value) {
        link.value = contract.link + '?tab=gavdetails'
      }
    }
  }
})

function makeMinimumSalaryRequest() {
  const rules = Object.keys(gavStore.answers).map((item) => {
    return gavStore.answers[item]
  })
  postApiMinimumsalaryByEditionIdResult({
    client,
    path: { editionId: edition.value },
    query: { language: textStore.language },
    body: rules
  })
    .then((response) => {
      if (response.data) {
        gavStore['result'] = response.data
        emit('complete', response.data)
      } else {
        gavStore['result'] = null
      }
    })
    .catch((error) => {
      console.log(error)
    })
}

async function onSelect(criteria, option) {
  gavStore.answers[criteria.id] = JSON.parse(option)
  let children = dependencies.value[criteria.id]
  if (children)
    children.forEach(async (child) => {
      gavStore.answers[child.id] = null
      await fetchChoicesForCriteria(edition.value, child)
    })
  formSteps.value.current$.validate()
  nextStep()
}

async function onClear(criteria) {
  gavStore.answers[criteria.id] = null
}

const value = ref(33)

const formSteps = ref(null)

function nextStep() {
  if (formSteps.value.isAtLastStep) return
  formSteps.value.next()

  if (formSteps.value.isAtLastStep) {
    posthog.capture('gav_form_complete')
    makeMinimumSalaryRequest()
  }
}
function previousStep() {
  formSteps.value.previous()
}

async function onStepChange(active, previous) {
  posthog.capture('gav_step_change', {
    step: active.index,
    previous: previous.index
  })
  if (previous.index == undefined) {
    document.body.classList.remove('reverse')
  } else if (active.index > previous.index) {
    document.body.classList.remove('reverse')
  } else {
    document.body.classList.add('reverse')
  }
  if (active.index < choices.value.length) {
    await fetchChoicesForCriteria(edition.value, choices.value[active.index])

    if (criteriaChoices.value[choices.value[active.index].id].length == 0) {
      if (active.index > previous.index) {
        nextStep()
      } else {
        previousStep()
      }
      return
    }
  }

  value.value = active.index
}

async function resetProgress() {
  structure.value = null
  value.value = 0
  choices.value = []
  criteriaChoices.value = {}
  dependencies.value = {}
  gavStore.answers = {}
  buildingForm.value = true
  gavStore.result = null
}

if (
  gavStore.branche != resultStore.request.branche.pk ||
  gavStore.onrp != resultStore.request.plz.onrp
) {
  resetProgress()
}
gavStore.onrp = resultStore.request.plz.onrp
gavStore.branche = resultStore.request.branche.pk

function getSelected() {
  for (let contract of contracts.value) {
    if (contract.editionId == edition.value) {
      return contract.contractName
    }
  }
}

function toggleMindestlohn() {
  openMindestlohn.value = !openMindestlohn.value
  if (openMindestlohn.value) {
    posthog.capture('gav_open')
  }
}

const showOptions = ref(false)
const t = inject('t')
</script>

<template>
  <div v-if="loading" class="loaderContainer">
    <span class="loader"></span>
  </div>

  <div id="gav-accordions" class="accordions" v-if="contracts && contracts.length > 0">
    <div class="entry header">
      <h3 @click="toggleMindestlohn()">
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.68359 19.3711V17.3711H6.68359V10.3711C6.68359 8.98776 7.10026 7.76276 7.93359 6.69609C8.76693 5.61276 9.85026 4.90443 11.1836 4.57109V3.87109C11.1836 3.45443 11.3253 3.10443 11.6086 2.82109C11.9086 2.52109 12.2669 2.37109 12.6836 2.37109C13.1003 2.37109 13.4503 2.52109 13.7336 2.82109C14.0336 3.10443 14.1836 3.45443 14.1836 3.87109V4.57109C15.5169 4.90443 16.6003 5.61276 17.4336 6.69609C18.2669 7.76276 18.6836 8.98776 18.6836 10.3711V17.3711H20.6836V19.3711H4.68359ZM12.6836 22.3711C12.1336 22.3711 11.6586 22.1794 11.2586 21.7961C10.8753 21.3961 10.6836 20.9211 10.6836 20.3711H14.6836C14.6836 20.9211 14.4836 21.3961 14.0836 21.7961C13.7003 22.1794 13.2336 22.3711 12.6836 22.3711ZM8.68359 17.3711H16.6836V10.3711C16.6836 9.27109 16.2919 8.32943 15.5086 7.54609C14.7253 6.76276 13.7836 6.37109 12.6836 6.37109C11.5836 6.37109 10.6419 6.76276 9.85859 7.54609C9.07526 8.32943 8.68359 9.27109 8.68359 10.3711V17.3711Z"
            fill="#e2001a"
          />
        </svg>
        <span> {{ t('geregelte-arbeitsbedingungen') }} </span>
      </h3>
    </div>

    <div class="entry" id="gavForm">
      <h3 :class="{ active: openMindestlohn }" @click="toggleMindestlohn()">
        <span> {{ t('erfahre-deinen-mindestlohn') }} </span>
        <svg
          class="arrow"
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.5332 10.0635L11.1754 20.4216L0.817292 10.0635"
            stroke="#34333C"
            stroke-width="2.37"
          />
          <line
            x1="11.1422"
            y1="19.7344"
            x2="11.1422"
            y2="0.946712"
            stroke="#34333C"
            stroke-width="2.37"
          />
        </svg>
      </h3>
      <div class="content" :class="{ hidden: !openMindestlohn }">
        <p>
          {{ t('überprüfe-hier-deinen-mindestlohn') }}
        </p>

        <div class="contractSelect">
          {{ t('dein-gesamtarbeitsvertrag') }}
          <div
            class="selected"
            :class="{ open: showOptions, one: contracts.length == 1 }"
            @click="contracts.length > 1 ? (showOptions = !showOptions) : null"
          >
            <svg
              width="39"
              height="39"
              viewBox="0 0 41 41"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              v-if="contracts.length > 1"
            >
              <path
                d="M11.6481 28.8732H13.308L24.6946 17.4867L23.0347 15.8267L11.6481 27.2133V28.8732ZM9.31836 31.203V26.2523L24.6946 10.9052C24.9276 10.6916 25.1848 10.5266 25.4663 10.4101C25.7479 10.2936 26.0439 10.2354 26.3546 10.2354C26.6652 10.2354 26.9661 10.2936 27.2573 10.4101C27.5485 10.5266 27.8009 10.7013 28.0145 10.9343L29.6162 12.5651C29.8492 12.7786 30.019 13.031 30.1258 13.3223C30.2326 13.6135 30.286 13.9047 30.286 14.1959C30.286 14.5065 30.2326 14.8026 30.1258 15.0841C30.019 15.3656 29.8492 15.6229 29.6162 15.8558L14.269 31.203H9.31836ZM23.8501 16.6712L23.0347 15.8267L24.6946 17.4867L23.8501 16.6712Z"
                fill="#34333C"
              />
            </svg>
            <span>
              {{ getSelected() }}
            </span>
          </div>
          <div class="contractOptions" :class="{ show: showOptions }">
            <template v-for="contract in contracts" :key="contract.contractNumber">
              <div
                v-if="edition != contract.editionId"
                @click="
                  () => {
                    edition = contract.editionId
                    showOptions = false
                    resetProgress()
                    fetchStructure()
                  }
                "
                class="contractOption"
              >
                {{ contract.contractName }}
              </div>
            </template>
          </div>
        </div>

        <div class="hint-no-minimum-salaray" v-if="gavHasNoSalary">
          {{ t('keine-mindestlohn-angaben') }}
          <a :href="link" target="_blank">
            {{ t('kein-milo-link') }}
          </a>
        </div>

        <div class="progress" v-if="formSteps && choices.length > 0">
          <ProgressIndicator
            circleColor="#fff"
            :showInner="true"
            :total="total - 1"
            :value="value"
          ></ProgressIndicator>
        </div>

        <Vueform
          v-if="choices.length > 0 && !buildingForm"
          :scrollOnNext="false"
          :validate-on="'step'"
          :addClass="'steps'"
          :endpoint="() => {}"
          ref="form$"
        >
          <template #empty>
            <FormSteps @select="onStepChange" ref="formSteps">
              <FormStep
                v-for="(choice, i) in choices"
                :key="'step-' + choice.id"
                :add-class="'step-indicator'"
                :remove-class="['vf-step']"
                :name="choice.title"
                :label="choice.title"
                :elements="['' + choice.id]"
                :labels="i == 0 ? { next: 'Weiter' } : { next: 'Weiter', previous: 'Zurück' }"
              >
              </FormStep>
              <FormStep
                :name="'result'"
                :label="''"
                :elements="['result']"
                :labels="{ finish: 'Fertig' }"
              ></FormStep>
            </FormSteps>

            <FormElements>
              <SelectElement
                v-for="(choice, i) in choices"
                :key="choice.id"
                :name="'' + choice.id"
                :search="true"
                autocomplete="off"
                :native="false"
                :items="criteriaChoices['' + choice.id]"
                :rules="[
                  {
                    required: (form$, Validator) => {
                      return form$.el$(choice.id).items.length > 0
                    }
                  }
                ]"
                :placeholder="choice.title"
                :value-prop="'payload'"
                :label-prop="'label'"
                :label="choice.title"
                @select="(option) => onSelect(choice, option, i + 1)"
                @updated="(el$) => checkPrefill(el$, choice)"
                @clear="(el$) => onClear(choice, el$)"
              >
              </SelectElement>
              <StaticElement :name="'result'"> </StaticElement>
            </FormElements>

            <FormStepsControls
              :labels="false"
              class="later"
              :class="{ inactive: !canMoveForward() }"
            >
              <template #next>
                <div>
                  <svg
                    width="54"
                    height="54"
                    viewBox="0 0 54 54"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M37.958 26.395L26.9893 37.364L16.0204 26.395" stroke-width="3.04252" />
                    <line
                      x1="26.9817"
                      y1="35.7695"
                      x2="26.9817"
                      y2="16.7395"
                      stroke-width="3.04252"
                    />
                  </svg>
                </div>
              </template>
              <template #previous>
                <div>
                  <svg
                    width="54"
                    height="54"
                    viewBox="0 0 54 54"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.4014 27.9473L27.3701 16.9783L38.339 27.9472"
                      stroke-width="3.04252"
                    />
                    <line
                      x1="27.3777"
                      y1="18.5723"
                      x2="27.3777"
                      y2="37.6023"
                      stroke-width="3.04252"
                    />
                  </svg>
                </div>
              </template>
              <template #finish>
                <div>
                  <svg
                    width="54"
                    height="54"
                    viewBox="0 0 54 54"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  ></svg>
                </div>
              </template>
            </FormStepsControls>
          </template>
        </Vueform>
      </div>
    </div>
    <div class="entry" v-if="link != null">
      <a :href="link" target="_blank">
        <h3>
          {{ t('infos-zu-deinen-arbeitsbedingungen') }}
          <svg
            style="transform: rotate(-135deg)"
            class="arrow"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.5332 10.0635L11.1754 20.4216L0.817292 10.0635"
              stroke="#34333C"
              stroke-width="2.37"
            />
            <line
              x1="11.1422"
              y1="19.7344"
              x2="11.1422"
              y2="0.946712"
              stroke="#34333C"
              stroke-width="2.37"
            />
          </svg>
        </h3>
      </a>
    </div>
  </div>
</template>
<style scoped>
.loaderContainer {
  display: flex;
  align-content: center;
  justify-content: center;
  margin-top: 3em;
}

.loader {
  width: 48px;
  height: 48px;
  border: 3px solid var(--color-grey);
  border-radius: 50%;
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

.loader::after {
  content: '';
  box-sizing: border-box;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 3px solid transparent;
  border-bottom-color: #ff3d00;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.contractSelect {
  position: relative;
  padding-top: 1rem;
}

.contractSelect span {
  font-weight: 700;
}

.entry a {
  text-decoration: none;
  color: var(--color-text);
}

.contractOption:hover {
  background-color: #e6d9d9;
}

.contractOption {
  cursor: pointer;
  padding: 4px 1rem 4px calc(1rem + 41px + 0.5rem);
}

.contractOptions {
  position: absolute;
  background-color: #fff;
  border-radius: 5px;
  top: 95%;
  left: 0;
  right: 0;
  box-shadow: rgba(0, 0, 0, 0.1) 0 5px 4px;
  border-bottom-left-radius: 26px;
  border-bottom-right-radius: 26px;
  padding-top: 0.3rem;
  padding-bottom: 1rem;
  margin-left: -0.5rem;
  margin-right: -0.5rem;
  transform: translateY(-50%) scaleY(0);
  opacity: 0;
  transition:
    transform 200ms,
    opacity 200ms;
}

.contractOptions.show {
  transform: translate(0);
  z-index: 100;
  opacity: 1;
}

.entry.header {
  display: flex;
  flex-direction: row;
}

.entry svg.arrow {
  stroke: var(--color-text);
  height: calc(var(--font-size) * 1.5);
  flex: 0 0 auto;
}

.entry h3 {
  gap: 1rem;
}

.entry svg {
  flex: 0 0 auto;
}

.entry.header h3 {
  font-weight: 700;
}

.entry.header svg {
  border-radius: 100%;
  border: solid 2px #e2001a;
  padding: 5px;
}

.entry {
  position: relative;
  display: flex;
  flex-direction: column;
}

.entry .content.hidden {
  transform: scaleY(0);
  transform-origin: top;
  opacity: 0;
  z-index: -1;
  pointer-events: none;
  position: absolute;
  flex: 0;
}

.entry .content {
  transition: transform 200ms;
  position: relative;
  flex: 1;
  z-index: 50;
}

h3 {
  font-size: var(--font-size);
  font-weight: 400;
  margin: 0;
  cursor: pointer;
  transition: all 200ms;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

h3.active {
  font-weight: 700;
}

h3 svg {
  transition: all 200ms;
}

h3.active svg {
  transform: rotate(180deg);
}

.entry {
  background-color: #f9f1f1;
  border-bottom: solid 1px var(--color-text);
  padding: 20px 15px;
}

@media screen and (min-width: 768px) {
  .entry {
    padding: 20px 40px;
  }
}

.entry:first-child {
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
}

.entry:last-child {
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;
  border-bottom: none;
}

.accordions {
  display: flex;
  flex-direction: column;
  margin-top: 3em;
}

form.steps {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-areas: 'form' 'controls';
  grid-template-rows: auto 1fr;
  flex: 1 1 auto;
  width: 100%;
  grid-area: form;
  min-height: 160px;
  max-width: 520px;
  margin-right: auto;
  margin-left: auto;
}

.selected {
  display: flex;
  align-items: flex-start;
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
  margin-bottom: 2rem;
  margin-top: 0.3rem;
  cursor: pointer;
  margin-left: -0.5rem;
  margin-right: -0.5rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  border-radius: 26px;
  background: white;
  box-shadow: rgba(0, 0, 0, 0.1) 0 0px 5px;
}

.selected.open {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.selected svg {
  background: none;
  border: solid #34333c 2px;
  border-radius: 50%;
  margin-right: 1rem;
  padding: 0;
  aspect-ratio: 1 / 1;
  width: 37px;
  height: 37px;
}

.selected span {
  padding-top: 3px;
}

.selected.one {
  cursor: default;
  padding-top: 0.3rem;
  background-color: transparent;
  box-shadow: none;
}

.inactive {
  --color-signal: #afaeae;
}

.inactive .vf-btn-primary div {
  cursor: not-allowed;
}

.inactive .vf-btn-primary svg path,
.inactive .vf-btn-primary svg line {
  stroke: var(--color-signal);
}
</style>

<style>
.inactive button.vf-btn.vf-btn.vf-btn:hover {
  transform: scale(1) !important;
}
</style>
